export default "/images/624596ead2af5d82048a209243542179.avif";